// src/private/src/pages/app/clients/components/DatePresets.jsx
import React, { memo, useCallback } from 'react';
import { Chip, Stack } from '@mui/material';
import { DATE_PRESETS } from './dashboardUtils';

/**
 * Horizontal row of quick date-range preset chips.
 * Calls `onSelect({ startDate, endDate })` when a preset is clicked.
 */
function DatePresets({ onSelect, activeLabel }) {
  const handleClick = useCallback(
    (preset) => {
      const range = preset.getRange();
      onSelect(range);
    },
    [onSelect]
  );

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {DATE_PRESETS.map((preset) => (
        <Chip
          key={preset.label}
          label={preset.label}
          size="small"
          variant={activeLabel === preset.label ? 'filled' : 'outlined'}
          color={activeLabel === preset.label ? 'primary' : 'default'}
          onClick={() => handleClick(preset)}
          sx={{
            cursor: 'pointer',
            fontWeight: 500,
            fontSize: '0.7rem',
          }}
        />
      ))}
    </Stack>
  );
}

export default memo(DatePresets);
